import { useEffect, useState } from 'react';
import { useUserProfilePreferences } from '@userProfile/userProfilePreferences.hooks';
import { EUserProfilePreferenceAttributeName } from '@userProfile/userProfilePreferences.constants';
import { useIsFirstRender } from '@gcl/react-core';
import { useAppConfigs } from '@config/config.hooks';

export const useDrawerOpenState = (attributeName: EUserProfilePreferenceAttributeName | undefined, enabled = true) => {
  const isFirst = useIsFirstRender();
  const appConfig = useAppConfigs();

  const defaultIsCollapse = useUserProfilePreferences<boolean | undefined>(
    attributeName,
    undefined,
    isFirst && enabled,
  );

  const state = useState(false);
  const [isOpen, setIsOpen] = state;

  useEffect(() => {
    if (defaultIsCollapse === undefined) return;
    setIsOpen(!defaultIsCollapse);
  }, [defaultIsCollapse]);

  useEffect(() => {
    if (enabled)
      appConfig?.updateConfigs?.((configs) => {
        return { ...configs, isDetailPageDrawerOpen: isOpen };
      });

    return () => {
      appConfig?.updateConfigs?.((configs) => {
        return { ...configs, isDetailPageDrawerOpen: false };
      });
    };
  }, [isOpen]);

  return state;
};
